import { combineReducers } from "redux";
import preProReducer from "./pre_processor/reducer";
import auth from "./auth/reducer";
import proReducer from "./processor/reducer";
import validator from "./validator/reducer";
import administrator from "./administrator/reducer";
import shared from "./shared/reducer";
import applicationConfigsReducer from "./application_configs/reducer";

const appReducer = combineReducers({
  auth: auth,
  prePro: preProReducer,
  pro: proReducer,
  vali: validator,
  admin: administrator,
  shared: shared,
  applicationConfigsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    state = {
      applicationConfigsReducer: state?.applicationConfigsReducer,
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
